// extracted by mini-css-extract-plugin
export default {"left":"split_left__qRJ03","right":"split_right__O7bYL","line":"split_line__nepqN"};